import React from "react";
import "./Textfield.scss";

const Textarea = (props) => {
	return (
		<textarea
			rows={props.rows}
			cols={props.cols}
			value={props.value}
			className="textarea"
			placeholder={props.placeholder}
			onChange={(e) => {
				props.setbrief
					? props.setbrief(e.target.value)
					: props.setdetail(e.target.value);
			}}
		/>
	);
};
export default Textarea;
